import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddAsset = createAsyncThunk(
  "asset/AddAsset",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/asset-create/`, data)
    return response.data
  }
); 

export const UpdateAsset = createAsyncThunk(
  "asset/UpdateAsset",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/asset-update/${data.id}/`, data)
    return response.data
  }
);

export const GetAssetList = createAsyncThunk(
  "asset/GetAssetList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/asset-list/`)
    return data
  }
);

export const GetAssetDetail = createAsyncThunk(
  "asset/GetAssetDetail",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/asset-detail/${id}/`)
    return data
  }
);


export const DeleteAsset = createAsyncThunk(
  "asset/DeleteAsset",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/asset-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

